// extracted by css-extract-rspack-plugin
export default {"entitiesSettingsPopup":"entitiesSettingsPopup__oJyD6","grammarCodeView":"grammarCodeView__kUkuP"};